import React from 'react';
import { useScreen } from '../../../styles';
import { get } from 'global/lib/lodash';
import clsx from 'clsx';
import { getColorFromScore } from '../../../styles';
import useStyles from '../styles';
import { avgItems, sumCount } from '../utils';

export const HeatChart = (props) => {
  const { isMobile } = useScreen();
  const classes = useStyles({ isMobile });
  const { 
    chart,
    getDisplayVal,
    findHeaderRow,
    getHeaderTitle,
    headerAvgTitle,
    colKey,
  } = props;

  const hasChartIndex = props.chartIndex !== undefined;
  const isSingleChart = !hasChartIndex;
  const useIndex = !props.chipFilters;

  const renderTable = (tab, i) => {
    if (hasChartIndex && props.chartIndex !== i && useIndex) { return null; } 

    return (
      <div key={i} className={clsx(isSingleChart && classes.chartWrapEach, classes.container, hasChartIndex && classes.removeBox)}>
        {!hasChartIndex && props.renderBar(tab, i)}
        <div className={classes.chartContainer}>
          <table>
            <thead className={'headercells'}>
              <tr className={classes.row}>
                <td className={classes.col_0}></td>
                {chart.header.map((h, i) => (
                  <HeaderCell key={i} val={h} getHeaderTitle={getHeaderTitle} {...props} />
                ))}
              </tr>
            </thead>
            <thead className="headerrow">
              <tr className={clsx(classes.row, classes.notopborder)}>
                <td className={clsx(classes.col, classes.col_0)}>{headerAvgTitle(tab, props.showCounts)}</td>
                {get(chart, `cols.${i}`, []).map((val, _i) => {
                  const ck = colKey(tab);
                  const foundHeaderRow = findHeaderRow(ck, val);
                  const headerRowItems = _i === 0 ? findHeaderRow(ck, get(chart, `cols.${i}`), true) || [] : [];
                  const value = ck
                    ? (_i === 0
                      ? avgItems(headerRowItems.map((hr) => ({ value: parseFloat(get(hr, 'calculated_value', 0)) })))
                      : parseFloat(get(foundHeaderRow, 'calculated_value')))
                    : avgItems(val);
                  const count = ck ? (_i === 0 ? headerRowItems.reduce((a, c) => a + get(c, 'count', 0), 0) : get(foundHeaderRow, 'count', 0)) : sumCount(val);
                  return (
                    <Cell
                      key={_i}
                      getDisplayVal={getDisplayVal}
                      i={_i}
                      {...props}
                      val={{
                        config: get(
                          val.find((f) => f.config),
                          'config'
                        ),
                        value,
                        count,
                      }}
                    />
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {tab.rows.map((row, _i) => {
                return (
                  <tr key={_i} className={classes.row}>
                    {row.map((r, __i) => (
                      <Cell key={__i} val={r} i={__i} {...props} getDisplayVal={getDisplayVal} />
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  return (
    <div className={hasChartIndex ? '' : classes.chartWrap}>
      {get(chart, 'tables', []).map(renderTable)}
    </div>
  )
};

const HeaderCell = (props) => {
  let { val, getHeaderTitle } = props;

  val = getHeaderTitle(props);

  const classes = useStyles();

  return (
    <td className={classes.col}>
      <div>
        <span>{get(val, 'value', get(val, 'name', typeof val === 'string' ? val : ''))}</span>
      </div>
    </td>
  );
};

export const Cell = (props) => {
  const { getDisplayVal, showCounts } = props;

  const { isLink, hasClick, scoreVal, display, slide } = getDisplayVal(props);

  const onClick = () => {
    if (isLink && hasClick) {
      hasClick();
    }
  };

  const classes = useStyles();
  const hasCount = get(props, 'val.count');
  const tooltip = get(props, 'val.tooltip');
  const displayCounts = showCounts && hasCount ? true : false;
  const bg = slide && !displayCounts ? getColorFromScore(scoreVal, slide) : '';

  return (
    <td
      onClick={onClick}
      title={tooltip || (hasCount ? `${hasCount} values` : undefined)}
      style={{ backgroundColor: bg }}
      className={clsx(classes.col, bg && classes.colHasBg, isLink && classes.rowLink)}
    >
      <span>{display}</span>
    </td>
  );
};
